module.exports = __webpack_public_path__ + "img/str_yt.b69a8af1.jpg";